<template>
  <div class="container">
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item>
        <h4 slot="label">
          <span></span>项目编号:
        </h4>
        <div class="form_id">{{formData.id}}</div>
      </el-form-item>
      <el-form-item label="*项目名称:">
        <el-input v-model="formData.name" placeholder="请输入项目名称"></el-input>
      </el-form-item>
      <el-form-item label="*图纸与技术文档:">
        <el-upload
          class="upload-demo"
          action="/v2/validate/Upload"
          :headers="myHeaders"
          :on-preview="handlePreview"
          :on-success="handleAvatarSuccess"
          :on-remove="handleRemove"
          multiple
          :limit="9"
          :file-list="fileList"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <span class="form_updata_span">（多图纸请打包上传）</span>
          <div slot="tip" class="el-upload__tip"></div>
        </el-upload>
      </el-form-item>
      <el-form-item label="*样件数量:">
        <el-input type="textarea" :rows="3" placeholder="请输入样件数量" v-model="formData.unit_num"></el-input>
      </el-form-item>
      <el-form-item label="*货运条款:">
        <el-select v-model="formData.freight" placeholder="请选择货运条款" style="display:block;">
          <el-option
            v-for="(item,index) in freightOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省市区" :label-width="formLabelWidth">
        <v-distpicker @selected="onSelected"></v-distpicker>
      </el-form-item>
      <el-form-item label="*期望发货日期：">
        <el-date-picker
          v-model="formData.freight_date"
          type="date"
          placeholder="选择发货日期日期"
          style="display:block;width: auto;"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="*详细需求：">
        <el-input type="textarea" :rows="8" placeholder="请描述详细需求" v-model="formData.demands"></el-input>
        <p class="form_p">
          请务必告诉我们
          <strong>零件工艺、材料、公差</strong>等信息，详细的需求有助于我们快速为您报价！
        </p>
      </el-form-item>
      <el-form-item>
        <div class="form_submit">
          <el-button type="primary" class="form_submit_bt" @click="createDemand()">提交需求</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "DemandContent",
  data() {
    return {
        formData:{}
    };
  },
  methods: {},
  created() {}
};
</script>
<style scoped>
</style>